// extracted by mini-css-extract-plugin
module.exports = {"imagePlaceholder":"ImagePlaceholder_imagePlaceholder___xyCo","noShadow":"ImagePlaceholder_noShadow__9_U29"};